import { Api } from '../../utils/api';
import { createLogger } from '../../utils/logger';

export class UsernameUniquenessService {
  private readonly api: Api;
  private readonly logger = createLogger('UsernameUniquenessService');
  private static instance: UsernameUniquenessService;

  constructor() {
    this.api = new Api(
      'username-uniqueness-api',
      '/username-uniqueness',
      'UsernameUniquenessService-Api'
    );
  }

  static getInstance() {
    if (!UsernameUniquenessService.instance) {
      UsernameUniquenessService.instance = new UsernameUniquenessService();
    }
    return UsernameUniquenessService.instance;
  }

  async checkUsernameUnique(username: string): Promise<boolean> {
    if (!username) return false;
    try {
      const data = await this.api.unauthenticatedRequest<{ usernameIsUnique: boolean }>(
        'GET',
        `?username=${username}`
      );
      return !!data.usernameIsUnique;
    } catch (error) {
      this.logger.error('Error checking username uniqueness', { error });
      return false;
    }
  }
}
